exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".full-width{width:100%!important}.bp-login-view{margin-top:50px}.bp-login-view .login-content{position:relative;max-width:320px;top:5vh;margin:0 auto}.bp-login-view .login-content .sign-in__logo{padding-top:50px}.bp-login-view .sign-in__footer{display:flex;justify-content:space-between;padding-top:25px}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/views/Signin/Signin.scss
 ** module id = 301
 ** module chunks = 0
 **/